import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AnimateHeight from "react-animate-height";
import MediaImg from "../media-img/component";
import SVG from "../svg/component";
import CmsMarkdown from "../basic/cms-markdown";

import { useMediaQuery } from "react-responsive";
import { COMPONENTS } from "../../constants";

import {
  card,
  card_inner,
  button_container,
  content_container,
  image_container,
  hidden_content_container,
  is_open
} from "./styles.module.scss";

const PeekabooCard = ({ name, subheader, description, image, brand, url }) => {
  const [active, setActive] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 960px)" });
  const backgroundColors = {
    redirock: "#D3242B",
    polebase: "#FCB71B",
    rosetta: "#8A2062",
    truemont: "#092B49",
    rediscapes: "#42856A",
    novumwall: "#323ba7"
  };
  const backgroundColor = backgroundColors[brand] || backgroundColors.redirock;

  return (
    <div
      className={classNames(card, {
        [is_open]: active
      })}
      style={{ backgroundColor: backgroundColor }}
    >
      {url ? (
        <a href={url} className={card_inner}>
          <div className={image_container}>
            <MediaImg media={{ data: true, ...image?.data?.attributes }}></MediaImg>
          </div>
          <div className={content_container} style={{ backgroundColor: backgroundColor }}>
            <h3>{name}</h3>
            <span>{subheader}</span>
          </div>
        </a>
      ) : (
        <div className={card_inner}>
          <div className={image_container}>
            <MediaImg media={{ data: true, ...image?.data?.attributes }}></MediaImg>
          </div>
          <div className={content_container} style={{ backgroundColor: backgroundColor }}>
            <h3>{name}</h3>
            <span>{subheader}</span>
          </div>
        </div>
      )}
      {!isMobile && (
        <button
          onClick={() => setActive(!active)}
          className={button_container}
          style={{ backgroundColor: backgroundColor }}
        >
          <SVG name="angle-down"></SVG>
        </button>
      )}
      <AnimateHeight
        animateOpacity={true}
        className={hidden_content_container}
        style={{ backgroundColor: backgroundColor }}
        duration={400}
        height={active || isMobile ? "auto" : 0}
      >
        <CmsMarkdown content={description} />
      </AnimateHeight>
    </div>
  );
};

PeekabooCard.propTypes = {
  name: PropTypes.string,
  subheader: PropTypes.string,
  description: PropTypes.node,
  image: PropTypes.object,
  brand: PropTypes.string,
  url: PropTypes.string
};

PeekabooCard.defaultProps = {
  name: "Redi-Rock",
  subheader: "Commerical Retaining Walls",
  description: {
    __typename: COMPONENTS.MARKDOWN,
    text: "Unleashing the possibility of people, products, and technology to create large block retaining wall solutions you can trust for a lifetime.  \n\n\n",
    id: "752",
    align_text: "left",
    name: "test"
  },
  image: {
    url: "https://aster-brands.imgix.net/redi-rock/727cd78b_f939_11e6_9e0d_8879c674f368_75c360cea9.jpg?auto=format%2Ccompress&w=600"
  },
  backgroundColor: "#d12229"
};
export default PeekabooCard;
